var React = require('react');

function DownInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Page 1"),React.createElement("g",{"id":"Y2_Students","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"id":"Desktop-HD","transform":"translate(-342.000000, -721.000000)","fill":"#000000"},React.createElement("polygon",{"id":"Page-1","transform":"translate(360.381155, 728.500000) scale(1, -1) translate(-360.381155, -728.500000) ","points":"360.381113 721 342 736 344.655987 736 360.381113 723.175379 376.097808 736 378.763069 736"})))]);
}

DownInline.defaultProps = {"width":"37px","height":"15px","viewBox":"0 0 37 15","version":"1.1"};

module.exports = DownInline;

DownInline.default = DownInline;
